export const removeTrailingSlash = (input: string) => {
  return input.replace(/\/$/, "")
}
